const MM_TO_PT = 72 / 25.4;

const textEncoder = new TextEncoder();

function mmToPt(valueMm) {
  return Number(valueMm) * MM_TO_PT;
}

function encodeText(content) {
  return textEncoder.encode(content);
}

function base64ToUint8Array(base64) {
  const binary = atob(base64);
  const len = binary.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
}

function padOffset(value) {
  return String(value).padStart(10, "0");
}

function concatUint8Arrays(arrays) {
  const totalLength = arrays.reduce((sum, arr) => sum + arr.byteLength, 0);
  const result = new Uint8Array(totalLength);
  let offset = 0;
  arrays.forEach((arr) => {
    result.set(arr, offset);
    offset += arr.byteLength;
  });
  return result;
}

function buildPdf(objects) {
  let offset = 0;
  const offsets = ["0000000000 65535 f \n"];
  const parts = [];

  const pushPart = (part) => {
    parts.push(part);
    offset += part.byteLength;
  };

  pushPart(encodeText("%PDF-1.4\n"));

  objects.forEach((object, index) => {
    offsets[index + 1] = `${padOffset(offset)} 00000 n \n`;
    pushPart(encodeText(`${index + 1} 0 obj\n`));
    object.forEach((p) => pushPart(p));
    pushPart(encodeText("\nendobj\n"));
  });

  const xrefOffset = offset;
  pushPart(encodeText(`xref\n0 ${objects.length + 1}\n`));
  pushPart(encodeText(offsets.join("")));
  pushPart(encodeText(`trailer\n<< /Size ${objects.length + 1} /Root 1 0 R >>\n`));
  pushPart(encodeText(`startxref\n${xrefOffset}\n%%EOF`));

  return concatUint8Arrays(parts);
}

async function pngToJpegBytes(base64Png) {
  const image = new Image();
  image.src = `data:image/png;base64,${base64Png}`;

  await new Promise((resolve, reject) => {
    image.onload = () => resolve(null);
    image.onerror = () => reject(new Error("Не удалось загрузить изображение WB"));
  });

  const canvas = document.createElement("canvas");
  canvas.width = image.width;
  canvas.height = image.height;
  const ctx = canvas.getContext("2d");
  ctx.drawImage(image, 0, 0);

  const jpegDataUrl = canvas.toDataURL("image/jpeg", 1);
  const base64Jpeg = jpegDataUrl.split(",")[1];
  const jpegBytes = base64ToUint8Array(base64Jpeg);

  return {
    jpegBytes,
    width: image.width,
    height: image.height,
  };
}

export async function createWbStickerPdfBlob(base64Png, sizeMm) {
  const pageWidth = mmToPt(sizeMm.width);
  const pageHeight = mmToPt(sizeMm.height);

  const { jpegBytes, width, height } = await pngToJpegBytes(base64Png);

  const contentStream = encodeText(
    `q\n${pageWidth.toFixed(2)} 0 0 ${pageHeight.toFixed(2)} 0 0 cm\n/Im0 Do\nQ`,
  );

  const imageStreamHeader = encodeText(
    `<</Type /XObject /Subtype /Image /Width ${width} /Height ${height} /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ${jpegBytes.length}>>\nstream\n`,
  );
  const imageStreamFooter = encodeText("\nendstream");

  const objects = [
    [encodeText("<</Type /Catalog /Pages 2 0 R>>")],
    [encodeText("<</Type /Pages /Kids [3 0 R] /Count 1>>")],
    [
      encodeText(
        `<</Type /Page /Parent 2 0 R /Resources <</ProcSet [/PDF /ImageC] /XObject <</Im0 5 0 R>>>> /MediaBox [0 0 ${pageWidth.toFixed(2)} ${pageHeight.toFixed(2)}] /Contents 4 0 R>>`,
      ),
    ],
    [
      encodeText(`<</Length ${contentStream.length}>>\nstream\n`),
      contentStream,
      encodeText("\nendstream"),
    ],
    [imageStreamHeader, jpegBytes, imageStreamFooter],
  ];

  const pdfBytes = buildPdf(objects);
  return new Blob([pdfBytes], { type: "application/pdf" });
}
